import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useRejectionReason = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onGetRejectionReasonError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while indicating issues.',
        );
    };

    const onGetRejectionReasonSuccess = (callback: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message ?? 'Rejection reason indicated successfully.');
        callback();
    };

    const setRejectionReasons = (data: {
        issue: string;
    }, driverId: string, callback: () => void) => {
        const url: HttpConfig = {
            url: `ba/v1/drivers/verification/${driverId}/reject-driver?issueType=${data.issue}`,
            method: 'delete',
            data,
        };

        request(url, onGetRejectionReasonSuccess(callback), setLoading, onGetRejectionReasonError);
    };

    return { setRejectionReasons, loading };
};

export default useRejectionReason;
